import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen, Line} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Column,Panel,Display,Card} from 'ktm-ui';
import CustomToolTip from 'components/CustomToolTip';

interface IdsBenCat {
    Id:string;
    Name:string;
    Description:string;
    Policy_Id:string;
    ExcludeTeladoc: boolean;
    ExcludeCorehealth: boolean;
};

interface IdsPolicy {
    Id: string;
    HasTeladoc: boolean;
    HasCorehealth: boolean;
}

export default KTMScreen({name:"enroll.bencat.edit"}, 
class extends React.Component<{bencat_id:string, disableIsHidden: boolean}> {

    data:{
        dsBenCat:IdsBenCat;
        dsPolicy: IdsPolicy;
    }

    // Store original data for comparison
    originalData: IdsBenCat | null = null;

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsBenCat";
        await KTMApi.start(screen,{
            "@bencat_id":this.props.bencat_id,
        });
        screen.title = "Edit Benefit Category";

        // Store a copy of the original data
        this.originalData = { ...this.data.dsBenCat };
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.main_tab)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Edit Benefit Category"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Save" size="large" style="primary"/>
            </Dialog.Footer>
        );
    }

    main_tab({field,draw,action}:RenderEvent){
        return (
            <Panel>
                <Column>
                    {draw(this.details)}
                </Column>
            </Panel>
        );
    }

    details({field,draw,action}:RenderEvent){
      
        return (
            <Card>
                <Display field={field("Name")}/>
                <Display field={field("Description")}/>
                <Line>
                    <Display 
                        field={field("IsHidden")} 
                        toolTip={
                            <CustomToolTip
                            header="Is Hidden"
                            bodyContent="If checked, this benefit category will not be visible to plan admin. You only can check if there are no employees enrolled in this benefit category, otherwise the checkbox will be disabled."
                            />
                        }
                    />
                    <Display 
                        field={field("IsEBOnly")} 
                        toolTip={
                            <CustomToolTip
                            header="Enhanced Benefits Only"
                            bodyContent="If checked, employees are only eligible for Enhanced Benefits and will not be eligible under the general HSA/LSA benefit."
                            />
                        }
                    />
                </Line>
                {(this.data.dsPolicy.HasTeladoc || this.data.dsPolicy.HasCorehealth) && <>
                    <Line>
                        {this.data.dsPolicy.HasTeladoc ? (
                            <span style={{ color: 'red' }}>
                                <Display field={field("ExcludeTeladoc")} />
                            </span>
                        ) : <></>}
                        {this.data.dsPolicy.HasCorehealth ? (
                            <span style={{ color: 'red' }}>
                                <Display field={field("ExcludeCorehealth")} />
                            </span>
                        ) : <></>}
                    </Line>
                </>}
            </Card>
            );
        }

    getChangedFields(originalData, updatedData) {
        if (!originalData) return {};
  
        const changes = {};
        for (const key in updatedData) {
          if (updatedData[key] !== originalData[key]) {
            changes[key] = {
              oldValue:
                originalData[key] !== undefined ? originalData[key] : "N/A",
              newValue: updatedData[key] !== undefined ? updatedData[key] : "N/A",
            };
          }
        }
        return changes;
    }

    async submit({screen}:ActionEvent){
        // Track changes
        const changes = this.getChangedFields(
            this.originalData,
            this.data.dsBenCat
        );

        const logDetails = Object.entries(changes)
            .map(([key, value]) => {
            const change = value as { oldValue: any; newValue: any };
            return `${key}: ${change.oldValue} → ${change.newValue}`;
            })
            .join(" | ");

        const policyLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            Note: logDetails,
            Action: "Policy Update Benefit Category",
            PolicyId: this.data.dsPolicy.Id,
            }),
        };

        await KTMApi.action(screen,"submit",{
            "@dsBenCat.Name":this.data.dsBenCat.Name,
            "@dsBenCat.Description":this.data.dsBenCat.Description,
            "@dsBenCat.ExcludeTeladoc": this.data.dsBenCat.ExcludeTeladoc,
            "@dsBenCat.ExcludeCorehealth": this.data.dsBenCat.ExcludeCorehealth,
            "@bencat_id":this.props.bencat_id,
        }).then(() => {
            fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        });
        screen.close({"continue":true});
    }

});
